import moment from "moment";
export const formatDateInYYYYMMDD = (date: Date) => {
  return moment(date).format("YYYY-MM-DD");
};

export const formatDateInMMDDYYYY = (
  date: Date | string,
  includeTime: boolean = false
) => {
  if (includeTime) {
    return moment(date).format("M/D/YY h:mm A");
  }
  return moment(date).format("MM/DD/YYYY");
};

export const formatDate = (dateString: Date | string): string => {
  const formattedDate = moment(dateString).format("M/D/YY [at] h:mm A");
  return formattedDate;
};
export const formatDateToLongString = (isoDateString: string): string => {
  const formattedDate = moment(isoDateString).format("DD MMMM YYYY");
  return formattedDate;
};

export const formatDateToOnlyMonthAndYear = (isoDateString: string): string => {
  const formattedDate = moment(isoDateString).format("MMM YYYY");
  return formattedDate;
};
